<template>
  <div class="user-collectionInfo">
    <mt-header fixed title="收款信息">
      <router-link to="" slot="left">
        <mt-button icon="back" @click.native="$router.back(-1)"></mt-button>
      </router-link>
    </mt-header>

    <div class="wrap">
      <p class="userInfoDesc">真实姓名： &nbsp;&nbsp;&nbsp;&nbsp; {{userInfo.userName}}</p>
      <p class="userInfoDesc">手机号码： &nbsp;&nbsp; {{userInfo.userMobile}}</p>
      <p class="userInfoDesc" v-if="userInfo.userTaskState !== undefined && userInfo.userTaskState === 3">身份证号： {{userInfo.idNum}}</p>
<!--      <div class="action-wrap">-->
<!--        <p class="label">姓名</p>-->
<!--        <input v-model="user.name" disabled/>-->
<!--      </div>-->
<!--      <div class="action-wrap">-->
<!--        <p class="label">手机号</p>-->
<!--        <input v-model="user.phone" disabled maxlength="11" />-->
<!--      </div>-->
      <div class="action-wrap" v-if="userInfo.userTaskState === undefined || userInfo.userTaskState !== 3">
        <p class="label">身份证号:</p>
        <input placeholder="请填写本人的身份证号" v-model="idNum" v-on:blur="checkIdNum" maxlength="18" />
      </div>
      <div v-if="err.idNum" class="txt-red err-info">
        <i class="iconfont icon-info-circle"></i>
        {{ err.idNum }}
      </div>
      <div class="action-wrap">
        <p class="label">银行卡号:</p>
        <input placeholder="请填写本人的银行卡号" v-model="userBankCard" v-on:blur="checkUserBankCard"  maxlength="20" />
      </div>
      <div v-if="err.userBankCard" class="txt-red err-info">
        <i class="iconfont icon-info-circle"></i>
        {{ err.userBankCard }}
      </div>
    </div>
    <div style="color: darkred;margin: 10px 30px;font-size: 15px;">
      <i class="iconfont icon-info-circle"></i>
      温馨提示：<br>
      <p style="margin-top: 5px;margin-bottom: 5px">
        1、请如实填写本人的{{showIdNum() ? '身份证及' : '' }}银行卡号（卡状态正常、无冻结、无开户证件过期等情况），信息错误将无法给您发放佣金；
      </p>
      <p style="margin-top: 5px;margin-bottom: 5px">
        2、不支持港澳台用户提交信息；
      </p>
      <p style="margin-top: 5px;margin-bottom: 5px">
        3、不支持信用卡收款，请知悉。
      </p>
    </div>
    <div class="">
      <mt-button class="submitInfo" @click="handleSubmit">确 认, 下一步</mt-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import {getUserInfo, updateUserInfo} from "@api/user";
import {verifyBankCardNo, verifyIdNum } from "@utils/common";
export default {
  components: {},
  data() {
    return {
      name: "",
      phone: "",
      idNum: "",
      userBankCard: "",
      userInfo: {},
      err: {
        idNum: "",
        userBankCard: "",
      },
    };
  },
  created() {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    let data = {
      userNo : this.$store.getters.getUser.userId,
      Authorization : this.$store.getters.getUser.authorization
    }
    getUserInfo(data).then((res) => {
      // console.log(JSON.stringify(res.data))
      this.userInfo = res.data;
      this.phone = res.data.userMobile;
      this.idNum = res.data.idNum || '';
      this.userBankCard = res.data.userBankCard || '';
    }).catch((err) => {
    });

    Toast({
      message: '请确认您的收款信息并完成签约，否则将无法给您发放佣金',
      duration: 5000,
      className: 'user-collectionInfoToast',
      iconClass: 'icon icon-success'
      // position: 'top'
    });
  },
  methods: {
    showIdNum() {
      const ID = this.userInfo.idNum;
      return ID === undefined || ID === null || ID.trim() === '';
    },
    checkUserBankCard() {
      // 检测手机号码合法性
      window.scroll(0, 0);
      const Card = (this.userBankCard === undefined || this.userBankCard === null) ? '' : this.userBankCard;
      let verifyInfo = verifyBankCardNo(Card);
      this.err.userBankCard = verifyInfo.done ? "" : verifyInfo.errMsg;
    },
    checkIdNum() {
      // 检测手机号码合法性
      window.scroll(0, 0);
      const ID = (this.idNum === undefined || this.idNum === null) ? '' : this.idNum;
      let verifyInfo = verifyIdNum(ID);
      this.err.idNum = verifyInfo.done ? "" : verifyInfo.errMsg;
    },
    handleSubmit() {
      if (this.showIdNum()) {
        this.checkIdNum();
        this.checkUserBankCard();
        if (this.err.idNum !== "" || this.err.userBankCard !== "") {
          Toast("请先填写正确的收款信息");
          return;
        }
      } else {
        this.checkUserBankCard();
        if (this.err.userBankCard !== "") {
          Toast(this.err.userBankCard);
          return;
        };
      }

      const {idNum, userBankCard} = this;
      const data = { userBankCard, idNum, idCardType: 1 };
      updateUserInfo(data).then((res) => {
        if (res.code === 200) {
          if (this.userInfo.userTaskState !== undefined && this.userInfo.userTaskState === 3) {
            Toast("您已完成签约任务");
          } else {
            Toast("稍后请继续完成签约任务");
          }
          setTimeout(()=> {
            // this.$router.replace("/taskCenter");
            let xbgSigntype = sessionStorage.getItem("isXbgSign");
            if (xbgSigntype !== undefined && Boolean(xbgSigntype)) {
              // 需要补充身份证照片信息
              this.$router.push("/user/authentication");
            } else {
              this.$router.replace("/taskCenter");
            }
          }, 1000);
        } else {
          Toast(res.message);
        }
      }).catch((res)=>{
        Toast("确认收款信息异常，请稍后重试！");
      });
    },
  },
};
</script>
<style lang='less' scoped>
* {
  box-sizing: border-box;
  margin: 0;
}
.user-collectionInfo {
  background-color: #ffffff;
  // padding: 3.2vw;
  // padding-bottom: 26.6667vw;
  height: 100%;
  background: url("../../assets/images/currency.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 10px;
}

ul.info{
  margin: 20px;
  border-radius: 20px;
  background-color: #fff;
  padding:20px;
  li{
    padding:8px 0;
    font-size: 1rem;
    .label{
      margin-right: 5px;
    }
  }
}

.wrap {
  background-color: #ffffff;
  margin: 0 15px;
  margin-top: 60px;
  border-radius: 20px;
  padding: 10px 0;
  .err-info {
    font-size: 0.9rem;
    margin: 5px 25px;
    color: red;
  }
  .userInfoDesc {
    font-size: 4.5vw;
    margin: 10px 0px 10px 30px;
    color: black;
  }
}
.action-wrap {
  display: flex;
  align-items: center;
  width: 80vw;
  height: 13vw;
  margin: 15px auto;
  background-color: #f7f7f7;
  border-radius: 8px;
  // border-bottom: 0.1333vw solid rgb(240, 240, 240);
}
input {
  width: 70%;
  font-size: 5.2667vw;
  text-align: right;
  border: none;
  background-color: #f7f7f7;
  margin-right: 10px;
}
input::-webkit-input-placeholder {
  font-size: 3.4667vw;
  color: rgba(137, 137, 137, 0.6);
}
input::-moz-placeholder {
  font-size: 3.4667vw;
  color: rgba(137, 137, 137, 0.6);
}
input::-ms-input-placeholder {
  font-size: 3.4667vw;
  color: rgba(137, 137, 137, 0.6);
}
.select {
  text-align: right;
  width: 60%;
  font-size: 3.4667vw;
  color: rgba(137, 137, 137, 0.6);
  margin-right: 10px;
}
.selected {
  font-size: 4.6vw;
  color: #666666;
}
.label {
  width: 30%;
  //color: rgb(137, 137, 137);
  color: black;
  font-size: 4.5vw;
  text-indent: 10px;
}
.upload-info {
  height: 13.3333vw;
  line-height: 13.3333vw;
  background-color: rgb(250, 250, 250);
  margin: 0 -3.2vw;
  padding: 0 3.2vw;
}
.upload {
  // width: 82.9333vw / 1.2;
  // height: 49.3333vw / 1.2;
  width: 90vw;
  height: 30vh;
  display: block;
  margin: 10px auto;
  img {
    width: 100%;
    height: 100%;
    // object-fit: contain;
    border-radius: 14px;
  }
}
.warning {
  font-size: 3.2vw;
  color: rgba(168, 168, 168, 0.6);
}
.file {
  display: none;
}
.submit {
  width: 96vw;
  height: 16vh;
  margin: auto;
  background: url('../../assets/images/user/submit.png') no-repeat;
  background-size: 100% 100%;
}
.submitInfo {
  color: white;
  font-size: 20px;
  font-weight: 900;
  width: 80vw;
  height: 7vh;
  margin: 20px 40px;
  background-color: #40a9ff;
  background-size: 100% 100%;
}
</style>
